module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      充值中心\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "contentBody"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group-list"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form', {
    attrs: {
      "action": "https://api.abeiyun.com/weixin/pay/jsapi.php",
      "method": "post"
    }
  }, [_c('group', [_c('cell', {
    attrs: {
      "title": "账户余额"
    }
  }, [_c('span', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm.money) + "元")])]), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "充值金额",
      "placeholder": "请输入充值金额",
      "name": "pay_money"
    },
    model: {
      value: (_vm.pay_money),
      callback: function($$v) {
        _vm.pay_money = $$v
      },
      expression: "pay_money"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "销售编号",
      "placeholder": "可为空",
      "name": "pay_saleuser"
    },
    model: {
      value: (_vm.pay_saleuser),
      callback: function($$v) {
        _vm.pay_saleuser = $$v
      },
      expression: "pay_saleuser"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "充值方式",
      "value": "微信",
      "is-link": ""
    }
  })], 1), _vm._v(" "), _vm._m(1)], 1)])]), _vm._v(" "), _c('toast', {
    staticClass: "zjwToast",
    attrs: {
      "type": _vm.tipType,
      "width": "4.5rem",
      "text": _vm.tiptxt,
      "time": 1800,
      "is-show-mask": "",
      "position": _vm.position
    },
    model: {
      value: (_vm.showPositionValue),
      callback: function($$v) {
        _vm.showPositionValue = $$v
      },
      expression: "showPositionValue"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-warn"
  }, [_c('p', [_vm._v("充值最小金额1.00元，充值金额必须为整数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moneyBtn"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("充值")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15bf0a26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/payment.vue
// module id = loMf
// module chunks = 1